module.exports = __webpack_public_path__ + "img/1.49bc9613.jpg";